module.exports = __webpack_public_path__ + "img/sunstar.d850055a.png";